// external libs
import React from 'react'

// Material-UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

// components
import Button from './../../../../control/button/button'
import ButtonSubmittedWithdraw from './_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

// hooks & stores
import useTranslate from '../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../stores/manageProject/useManageProjectStore'

// constants
import constSubmittedType from '../../../../constants/submittedType'

type PageActionViewType = {
    onClickSaveDraft?: () => void
    disableDraft?: boolean
    onClickSave?: () => void
    disabledSave?: boolean
    onClickClose?: () => void
    onClickDeleteProject?: () => void
    isViewMode?: boolean
}
const PageActionView: React.FC<PageActionViewType> = (props) => {
    const {
        onClickSaveDraft,
        onClickSave,
        onClickClose,
        onClickDeleteProject,
        isViewMode = false,
        disableDraft,
        disabledSave,
    } = props
    const translate = useTranslate()
    const theme = useTheme()
    const classes = useStyles()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const { projectData } = useManageProjectStore()
    const isNotFirstSubmit = projectData?.submitTypeInfo.value !== constSubmittedType.firstSubmitConsideration

    return (
        <Grid container justify={'space-between'} className={classes.container}>
            <Grid item xs={12} sm={'auto'}>
                <Grid container spacing={2}>
                    {onClickDeleteProject && (
                        <Grid item xs={12} sm={'auto'}>
                            <Button
                                size={'medium'}
                                fullWidth={isMobileView ? true : false}
                                variant="contained"
                                color="default"
                                onClick={onClickDeleteProject}
                            >
                                {isNotFirstSubmit
                                    ? translate.get('BUTTON.CANCEL_DRAFT')
                                    : translate.get('BUTTON.DELETE_PROJECT')}
                            </Button>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={'auto'}>
                        {onClickSaveDraft && (
                            <Button
                                size={'medium'}
                                fullWidth={isMobileView ? true : false}
                                variant="contained"
                                color="default"
                                disabled={disableDraft}
                                onClick={onClickSaveDraft}
                            >
                                {translate.get('BUTTON.SAVE_DRAFT')}
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={'auto'}>
                {!isViewMode && (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={'auto'}>
                            <Button
                                size={'medium'}
                                variant="contained"
                                className={classes.cancelButton}
                                onClick={onClickClose}
                                fullWidth={isMobileView ? true : false}
                            >
                                {translate.get('BUTTON.CANCEL')}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={'auto'}>
                            <Button
                                size={'medium'}
                                variant="contained"
                                color="primary"
                                onClick={onClickSave}
                                disabled={disabledSave}
                                className={classes.saveButton}
                                fullWidth={isMobileView ? true : false}
                            >
                                {translate.get('BUTTON.SAVE')}
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}

export default PageActionView

export const ButtonSign: React.FC<PageActionViewType> = (props) => {
    const { onClickSave, onClickClose } = props
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    return (
        <Grid container justify="space-between" spacing={2} style={{ marginTop: '8px' }}>
            <Grid item xs={10} sm={'auto'}>
                <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
            </Grid>

            <Grid item>
                <Button
                    size={'large'}
                    variant="contained"
                    onClick={onClickClose}
                    style={{
                        backgroundColor: '#FFFFFF',
                        border: 'solid 1px #db5f8e',
                        minWidth: '0px',
                        marginRight: '20px',
                    }}
                >
                    {translate.get('BUTTON.CANCEL')}
                </Button>

                <Button size={'large'} variant="contained" color="primary" onClick={onClickSave}>
                    {translate.get('BUTTON.SIGN_CERTIFICATE')}
                </Button>
            </Grid>
        </Grid>
    )
}

export const ButtonClose: React.FC<PageActionViewType> = (props) => {
    const { onClickClose } = props
    const translate = useTranslate()
    const classes = useStyles()

    return (
        <Grid container item xs={12} md={12} lg={12} style={{ padding: '8px 0px' }}>
            <Grid container item justify="flex-end">
                <Button variant="contained" color="primary" onClick={onClickClose} className={classes.saveButton}>
                    {translate.get('BUTTON.CLOSE')}
                </Button>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    saveButton: {
        border: 'solid 1px #db5f8e',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
        [theme.breakpoints.down('xs')]: {
            marginTop: '16px',
        },
    },
    container: {
        padding: '8px 0px',
    },
}))
